import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { WebcamModule } from 'ngx-webcam';
import { HeaderComponent } from './components/layouts/header/header.component';
import { SidebarComponent } from './components/layouts/sidebar/sidebar.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { ForgotPasswordComponent } from './components/pages/forgot-password/forgot-password.component';
import { VisitorHomeComponent } from './visitor-home/visitor-home.component';
import { VisitorPhoneComponent } from './visitor-phone/visitor-phone.component';
import { VisitorOtpVerificationComponent } from './visitor-otp-verification/visitor-otp-verification.component';
import { VisitorDetailsComponent } from './visitor-details/visitor-details.component';
import { VisitorSelfieComponent } from './visitor-selfie/visitor-selfie.component';
import { VisitorEntryComponent } from './visitor-entry/visitor-entry.component';
import { VisitorCameraComponent } from './visitor-camera/visitor-camera.component';
import { VisitorProofidComponent } from './visitor-proofid/visitor-proofid.component';
import { VisitorThankYouComponent } from './visitor-thank-you/visitor-thank-you.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    VisitorHomeComponent,
    VisitorPhoneComponent,
    VisitorOtpVerificationComponent,
    VisitorDetailsComponent,
    VisitorSelfieComponent,
    VisitorEntryComponent,
    VisitorCameraComponent,
    VisitorProofidComponent,
    VisitorThankYouComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule, 
    ToastrModule.forRoot({
      timeOut: 1000,
      positionClass: 'toast-top-right'
    }),   
     WebcamModule
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
